export default __webpack_public_path__ + "static/media/settings.c1a3673c.svg";